<template>
  <div class="card p-shadow-app">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <ConfirmDialog></ConfirmDialog>

    <h1>Lista Categorias de Tickets</h1>
    <Divider />
    <div class="p-field p-grid">
      <div class="p-col-12 p-md-3 p-mt-1">
        <Button
          label="Adicionar"
          icon="pi pi-plus"
          class="p-button-success"
          @click="addModel"
        />
      </div>
    </div>
    <Divider />
    <DataTable
      :value="modelList"
      :filters.sync="filters"
      filterDisplay="row"
      :loading="loading"
      :paginator="true"
      :rows="20"
      class="p-datatable-sm"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 25, 50]"
      currentPageReportTemplate="Mostrar {first} ao {last} de {totalRecords} faltas"
      responsiveLayout="scroll"
    >
      <template #empty> Não existem faltas. </template>
      <template #loading> A carregar. Por favor Aguarde... </template>
      <Column field="name" header="Nome" filterField="name">
        <template #body="slotProps">
          <span class="p-column-title">Nome:</span>
          {{ slotProps.data.name }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <InputText
            type="text"
            class="p-column-filter"
            v-model="filterModel.value"
            @input="filterCallback()"
          />
        </template>
      </Column>
      <Column
        field="active"
        header="Ativo"
        filterField="active"
        dataType="boolean"
        sortable
      >
        <template #body="slotProps">
          <span class="p-column-title">Activo:</span>
          {{ slotProps.data.active == true ? "Sim" : "Não" }}
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <Dropdown
            v-model="filterModel.value"
            @input="filterCallback()"
            :options="[
              { value: false, label: 'Não' },
              { value: true, label: 'Sim' },
            ]"
            optionValue="value"
            optionLabel="label"
            class="p-column-filter"
            :showClear="true"
          >
          </Dropdown>
        </template>
      </Column>

      <Column>
        <template #body="slotProps">
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success p-button-sm p-mr-2"
            @click="editModel(slotProps.data)"
          />
        </template>
      </Column>
    </DataTable>

    <Dialog
      :visible.sync="modelForm"
      :style="{ width: $isMobile() ? '100vw' : '50vw' }"
      :header="'Adicionar Categoria'"
      :modal="true"
      :contentStyle="{ overflow: 'hide' }"
    >
      <form
        name="modelForm"
        class="p-col-12"
        @submit.prevent="submitModel"
        style="min-height: 50vh"
      >
        <div class="p-fluid p-formgrid p-grid">

          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <InputText
                :disabled="modelItem.action == 'view'"
                type="text"
                v-model="modelItem.name"
                v-validate="modelItem.action == 'view' ? '' : 'required'"
                v-bind:class="[
                  { 'p-invalid': errors.has('name') },
                  'form-control',
                ]"
                :id="'name'"
                :name="'name'"
              />
              <label for="pats">Nome</label>
            </span>
            <small v-if="errors.has('name')" class="p-error" role="alert">
              Nome é obrigatório
            </small>
          </div>

          <div class="p-field p-col-12 p-md-6 p-mt-2" v-if="modelItem.id">
            <span
              class="p-float-label"
              style="top: -0.75rem; left: -1rem; font-size: 12px"
            >
              <label for="admission">Ativa</label>
            </span>
            <InputSwitch
              v-model="modelItem.active"
              name="admission"
              style="'top: 3px;"
            />
          </div>

        </div>
      </form>
      <template #footer>
        <Button
          v-if="modelItem.action != 'view'"
          :label="'Guardar'"
          icon="pi pi-check"
          class="p-button-sm p-button-success"
          @click="submitModel"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-sm p-button-danger"
          @click="closeForm"
        />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="deleteCategoryDialog"
      :style="{ width: '20vw' }"
      header="Eliminar Categoria"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span v-if="modelItem">
          <span> Tem a certeza que pretende eliminar esta falta? </span>
        </span>
      </div>
      <template #footer>
        <Button
          label="Sim"
          icon="pi pi-check"
          class="p-button-sm p-button-success"
          @click="deleteCategory"
        />
        <Button
          label="Não"
          icon="pi pi-times"
          class="p-button-sm p-button-danger"
          @click="deleteCategoryDialog = false"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import categoryService from "../../services/ticketsCategories.service";
import { FilterMatchMode } from "primevue/api/";

export default {
  name: "Miss",
  components: {
  },
  data() {
    return {
      loading: true,
      modelList: [],
      filters: {
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        active: { value: null, matchMode: FilterMatchMode.EQUALS },
      },
      modelItem: {},
      modelForm: false,
      deleteCategoryDialog: false,
    };
  },
  computed: {
    loggedUser() {
      return this.$store.state.auth.user;
    },
  },
  async created() {
    this.loading = true;
    this.userId = this.loggedUser.id;
    this.getModelList();
  },
  methods: {
    getModelList() {
      this.loading = true;
      return categoryService
        .getCategoryList()
        .then((response) => {
          this.loading = false;
          return (this.modelList = response);
        });
    },
    closeForm() {
      this.$validator.pause();
      this.$validator.reset();
      this.modelForm = false;
      this.modelItem = {};
    },
    addModel() {
      this.modelItem = {
        action: 'new',
        name: null,
        active: true
      };
      this.modelForm = true;
    },
    submitModel() {
      this.$validator.validateAll().then((isValid) => {
        if (
          !isValid ||
          (!this.modelItem.name)
        ) {
          return;
        }

        this.$validator.pause();
        this.$validator.reset();
        if (this.modelItem.action === "new") {
          return this.createModel();
        } else if (this.modelItem.action === "update") {
          return this.updateModel();
        }
      });
    },
    createModel() {
      return categoryService
        .createTicketCategory(this.modelItem)
        .then((response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: "Ocorreu um erro ao registar dados",
              life: 3000,
            });
          }
          this.modelList.unshift(response);
          this.$toast.add({
            severity: "success",
            summary: "Categoria registada",
            detail: "Dados registados com sucesso",
            life: 3000,
          });

          return response;
        })
        .then(() => this.closeForm());
    },
    editModel(info) {
      return this.loadModel("update", info);
    },
    loadModel(action, info) {
      this.modelItem = {
        action: action,
        id: info.id,
        name: info.name,
        active: info.active ? true : false
      }
      this.modelForm = true;
    },
    updateModel() {
      let data = {
        id: this.modelItem.id,
        name: this.modelItem.name,
        active: this.modelItem.active
      };

      return categoryService
        .updateTicketCategory(data.id, data)
        .then((response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: "Ocorreu um erro ao actualizar os dados",
              life: 3000,
            });
          }
          this.getModelList();
          this.$toast.add({
            severity: "success",
            summary: "Categoria actualizada",
            detail: "A dados actualizados com sucesso",
            life: 3000,
          });
        })
        .then(() => this.closeForm());
    },
    confirmDeleteCategory(info) {
      this.modelItem = info;
      this.deleteCategoryDialog = true;
    },
    deleteCategory() {
      this.deleteCategoryDialog = false;
      return categoryService.deleteTicketCategory(this.modelItem.id).then((response) => {
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Ocorreu um erro ao anular a falta",
            life: 3000,
          });
        }
        this.getModelList();
        return this.$toast.add({
          severity: "success",
          summary: "Falta anulada",
          detail: "A falta foi anulada com sucesso",
          life: 3000,
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
#year-selector {
  width: 60px;
}
.pdf-viewer {
  text-align: center;
}
</style>
